<section i18n-title="Trh práce" *ngIf="data && data.length" class="mt-3 d-none d-sm-block" [ngClass]="{'d-none': !show}">
  <div matBadge="{{data.length}}" matBadgeOverlap="false" matBadgeColor="warn" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6" i18n>Trh práce</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    <app-job-item *ngFor="let j of data" [job]="j"></app-job-item>
  </mat-expansion-panel>
</section>
